import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SopModels } from '../store/state/sops/sops.models';
import { api } from '../consts/url';

@Injectable({
  providedIn: 'root',
})
export class SopsService {
  private readonly httpClient = inject(HttpClient);

  public getSopsByOrganization(orgId: string): Observable<SopModels.SopEntity[]> {
    return this.httpClient.get<SopModels.SopEntity[]>(
      api.sops.getByOrganization(orgId),
    );
  }

  public getSopsByAccount(accountId: string): Observable<SopModels.SopEntity[]> {
    return this.httpClient.get<SopModels.SopEntity[]>(
      api.sops.getByAccount(accountId),
    );
  }

  public createSop(orgId: string, createData: SopModels.SopApiData): Observable<SopModels.SopEntity> {
    return this.httpClient.post<SopModels.SopEntity>(
      api.sops.createSop(orgId),
      this.buildFormData(createData),
    );
  }

  public updateSop(
    orgId: string,
    sopId: string,
    updateData: SopModels.SopApiData,
  ): Observable<SopModels.SopEntity> {
    return this.httpClient.put<SopModels.SopEntity>(
      api.sops.crud(orgId, sopId),
      this.buildFormData(updateData),
    );
  }

  public deleteSop(orgId: string, sopId: string): Observable<boolean> {
    return this.httpClient.delete<boolean>(api.sops.crud(orgId, sopId));
  }

  public duplicateSop(
    orgId: string,
    sopId: string,
  ): Observable<SopModels.SopEntity> {
    return this.httpClient.post<SopModels.SopEntity>(
      api.sops.duplicateSop(orgId, sopId),
      {},
    );
  }

  private buildFormData(data: SopModels.SopApiData): FormData {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('description', data.description ?? '');

    for (const accountId of data.accountIds) {
      formData.append('accountIds', accountId);
    }

    if (data.file) {
      formData.append('file', data.file, data.file.name);
    }

    return formData;
  }
}
